var _excluded = ["href", "appearance", "active", "disabled", "external", "children", "size", "innerRef", "onClick", "title", "qa", "as", "ariaLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Container from "./styles";
var Button = function Button(_ref) {
  var href = _ref.href,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'unstyled' : _ref$appearance,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    disabled = _ref.disabled,
    external = _ref.external,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    innerRef = _ref.innerRef,
    onClick = _ref.onClick,
    title = _ref.title,
    _ref$qa = _ref.qa,
    qa = _ref$qa === void 0 ? {} : _ref$qa,
    as = _ref.as,
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!href && external) {
    // eslint-disable-next-line no-console
    console.warn('Warning: external prop cannot be set without a href declaration');
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    title: title,
    active: active,
    href: href,
    target: external ? '_blank' : undefined,
    rel: external ? 'noopener noreferrer' : undefined,
    as: as || (href ? 'a' : 'button'),
    type: href ? undefined : 'button',
    "aria-disabled": disabled ? disabled : undefined,
    disabled: disabled,
    buttonSize: size,
    appearance: appearance || 'unstyled',
    ref: innerRef,
    onClick: onClick,
    "data-qa-button": title || '',
    "data-qa-button-isdisabled": disabled === true,
    "aria-label": ariaLabel
  }, qa, rest), children);
};
Button.displayName = 'Button';
export default Button;